<template>
    <div>
      <div class="logindiv" id="AddForm_huifu">
        <div class="loginForm">
          <div style="width: 100%;height: 40px;background-color: #2d2d2d;margin: 0 auto;">
            <span style="line-height: 40px;color: #FFFFFF;font-size: 14px;float: left;margin-left: 20px;">
              回复留言
            </span>
            <span style="line-height: 40px;color: #FFFFFF;font-size: 14px;float: right;margin-right: 20px;">
              <a href="javascript:;" @click="close">
                <i class="el-icon-close"></i>
              </a>
            </span>
          </div>
          <div style="width: 300px;margin: 0 auto;">
            <el-form :model="AddForm" :rules="rules" ref="AddForm" style="margin-top: 50px;">
              <el-form-item prop="content">
                <el-input type="textarea" :autosize="{ minRows: 3, maxRows: 5}" v-model="AddForm.content" placeholder="回复内容"></el-input>
              </el-form-item>
              <el-form-item>
                <el-button type="primary" :loading="loading" style="width: 300px;" @click="AddLabel">回复</el-button>
              </el-form-item>
            </el-form>
          </div>
          <br>
        </div>
      </div>
      <div>
        <el-container>
          <el-header style="background-color:white;margin-top: 5px;height: 40px;">
            <el-form :inline="true" :model="formInline" class="demo-form-inline" size="mini">
              <el-form-item label="留言用户">
                <el-input v-model="formInline.name" placeholder="留言人" class="elInput"></el-input>
              </el-form-item>
              <el-form-item label="起始日期">
                <el-date-picker v-model="formInline.statetime" type="date" value-format="yyyy-MM-dd" placeholder="起始日期"></el-date-picker>
              </el-form-item>
              <el-form-item label="结束日期">
                <el-date-picker v-model="formInline.endtime" type="date" value-format="yyyy-MM-dd" placeholder="结束日期"></el-date-picker>
              </el-form-item>
              <el-form-item>
                <el-button type="primary" class="btn" @click="getData()"><i class="el-icon-search"></i>查询</el-button>
              </el-form-item>
              <el-form-item>
                <el-button type="danger" class="btn" @click="resetting()"><i class="el-icon-refresh"></i>重置</el-button>
              </el-form-item>
            </el-form>
          </el-header>
          <el-main class="elMain">
            <el-table v-loading="loading" :data="tableData" height="100%" stripe border size="medium ">
              <el-table-column align="center" label="ID" prop="id" width="100"></el-table-column>
              <el-table-column align="center" label="留言人" prop="u_name" width="200"></el-table-column>
              <el-table-column align="center" label="内容" prop="content"></el-table-column>
              <el-table-column align="center" label="留言时间" prop="time" width="250"></el-table-column>
              <el-table-column align="center" label="回复内容" width="150">
                <template slot-scope="scope">
                  <span>
                    <el-popover placement="left" title="回复内容" width="350" trigger="click">
                      <div>
                        <hr>
                      </div>
                      <div v-for="scs in answer" :key="scs.index">
                        <div>
                          回复人:{{scs.admin_name}}
                        </div>
                        <div>
                          内容:<span style="font-size: 16px;margin-left: 5px;">{{scs.content}}</span>
                        </div>
                        <div>
                          <span>回复时间:{{scs.time}}</span>
                          <a href="javascript:;" style="color: #000000;" @click="deleteanswer(scs)">
                            <span style="float: right;margin-right: 10px;"><i class="el-icon-delete" ></i></span>
                          </a>
                        </div>
                        <div>
                          <hr>
                        </div>
                      </div>
                      <el-button size="small" slot="reference" @click="queryAnswer(scope.row)">回复内容</el-button>
                    </el-popover>
                  </span>
                </template>
              </el-table-column>
              <el-table-column fixed="right" label="操作" width="300">
                <template slot-scope="scope">
                  <span>
                    <el-button size="small" @click="Addwindow(scope.row)">回复</el-button>
                  </span>
                  <span>
                    <el-popconfirm
                      confirmButtonText='好的'
                      cancelButtonText='不用了'
                      icon="el-icon-info"
                      iconColor="red"
                      title="这是一段内容确定删除吗？"
                      @onConfirm="deletes(scope.$index, scope.row)"
                    >
                      <el-button size="small" slot="reference">删除</el-button>
                    </el-popconfirm>
                  </span>
                </template>
              </el-table-column>
            </el-table>
          </el-main>
          <el-footer>
            <div style="padding: 15px 0;text-align: right;">
              <el-pagination background @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page="formInline.pageNum"
                :page-sizes="pageSizes" :page-size="formInline.pageSize" layout="total, sizes, prev, pager, next, jumper" :total="pageTotal">
              </el-pagination>
            </div>
          </el-footer>
        </el-container>
      </div>
    </div>
</template>

<script>
  import {commonAPI} from '@/api/commonAPI'
  export default {
    data() {
      var content = (rule, value, callback) => {
        if (value.length === 0) {
          callback(new Error('请输入名称'))
        } else {
          callback()
        }
      }
      return {
        tableData: [],
        loading: false,
        formInline: {
          statetime:'',
          name:'',
          endtime:'',
          type:'0',
          pageNum:1,
          pageSize:10
        },
        pageSizes:[5, 10, 15, 20],
        pageTotal:0,
        AddForm:{
          admin_id:'',
          content:'',
          message_id:''
        },
        rules: {
          content: [{
            required: true,
            trigger: 'blur',
            validator: content
          }]
        },
        queryAnswers:{
          message_id:''
        },
        answer:[],
      }
    },
    created() {
      //this.getData();
    },
    //页面开启时执行
    mounted(){
      this.getData();
    },
    methods: {
      //重置查询
      resetting() {
        this.formInline.name = '';
        this.formInline.statetime = '';
        this.formInline.endtime = '';
        this.getData();
      },
      //删除回复
      deleteanswer(row){
        let admin_id=this.$store.state.a_id;
        row.admin_id=admin_id;
        commonAPI('deleteAnswer',row).then(res => {
          let data = res.data;
            //console.log(res.data.rows);
            if(this.response.response(data)){}
          }).catch(error=>{
              this.loading = false;
              this.$notify({//这里采用element ui的一个错误显示效果模板
                title: '提示',
                message: error.message,
                position: 'bottom-right',
                type: 'error'
              });
        })
      },
      //查找留言回复
      queryAnswer(row){
        this.answer='';
        this.queryAnswers.message_id=row.id;
        commonAPI('queryAnswer',this.queryAnswers).then(res => {
          this.answer=res.data.data.answerlist;
          this.queryAnswers.message_id="";
        })
      },
      //添加内容
      AddLabel(){
        this.$refs.AddForm.validate(valid => {
        if (valid) {
          this.AddForm.admin_id=this.$store.state.a_id;
          commonAPI('AddAnswer',this.AddForm).then(res => {
            let data = res.data;
            //console.log(res.data.rows);
            if(this.response.response(data)){
              this.AddForm.content='';
              this.close();
            }
          }).catch(error=>{
            this.loading = false;
            this.$notify({//这里采用element ui的一个错误显示效果模板
              title: '提示',
              message: error.message,
              position: 'bottom-right',
              type: 'error'
            });
            })
        }else{
          return false;
        }
        })
      },
      //打开窗口
      Updatewindow(index, row){
        this.UpdateForm.id=row.id;
        this.UpdateForm.name=row.name;
        this.UpdateForm.type=row.type;
        document.getElementById('UpdateForm').style.display='block';
      },
      Addwindow(row){
        this.AddForm.message_id=row.id;
        document.getElementById('AddForm_huifu').style.display='block';
        document.getElementById('zhedang').style.display='block';
        //console.log('打开窗口');
      },
      //删除
      deletes(index, row) {
        let admin_id=this.$store.state.a_id;
        row.admin_id=admin_id;
        row.u_photo="";
        //console.log(index, row);
        commonAPI('AdeleteMessage',row).then(res => {
          let data = res.data;
          //console.log(res.data.rows);
          if(this.response.response(data)){
            this.getData();
          }
        }).catch(error=>{
            this.loading = false;
            this.$notify({//这里采用element ui的一个错误显示效果模板
              title: '提示',
              message: error.message,
              position: 'bottom-right',
              type: 'error'
            });
            })
      },
      //查询
      getData() {
        this.loading = true,
          commonAPI('queryMessage',this.formInline).then(res => {
            this.loading = false;
            this.tableData = res.data.data.rows;
            this.pageTotal=res.data.data.total;
            //console.log(res.data.rows);
          })
      },
      onSubmit() {
        this.getData();
      },
      handleSizeChange(val) {
        //console.log(`每页 ${val} 条`);
        this.formInline.pageSize=val;
        this.formInline.pageNum=1;
        this.getData();
      },
      handleCurrentChange(val) {
        //console.log(`当前页: ${val}`);
        this.formInline.pageNum=val;
        this.getData();
      },
      close(){
        document.getElementById('AddForm_huifu').style.display='none';
        document.getElementById('zhedang').style.display='none';
        //document.getElementById('registermain').style.display='none';
        //document.getElementById('addliuyan1').style.display='none';
      },
    }
  }
</script>

<style scoped>
  .elInput,
  .btn {
    margin-top: 0px;
  }
  .el-main {
    padding: 5px 10px;
  }
  .elMain{
    height: 700px;
  }
  .el-table th {
    height: 45px;
    font-size: 16px;
    font-family: 微软雅黑;
    font-weight: 500;
    color: darkblue;
  }
  /**登录框架*/
  .logindiv{
    position: fixed;
    top: 25%;
    left:0;
    right:0;
    bottom: 0;
    margin:0 auto;
    padding: 20px;
    border: 0px solid #ddd;
    z-index:25;
    overflow: auto;
    text-align: center;
    display: none;
  }
  .loginForm{
    margin: 0 auto;
    width: 550px;
    background-color: #fff;
    -webkit-box-shadow: #333 0px 5px 5px;
    -moz-box-shadow: #333 0px 5px 5px;
    box-shadow: #333 0px 5px 5px;
  }
  .loginForm a{
    color: #fff;
  }
  .loginForm a:hover{
    color: #d6d6d6;
  }
</style>



// WEBPACK FOOTER //
// src/admin/views/massage/Liuyan.vue